/**
 * Admin subscriptions API endpoints.
 */

import { http } from './http';
import type { PaginatedResponse, Subscription, SubscriptionFilters } from './types';

/** GET /api/v1/admin/subscriptions */
export async function listSubscriptions(
  filters?: SubscriptionFilters,
): Promise<PaginatedResponse<Subscription>> {
  const params = new URLSearchParams();
  if (filters?.search) params.set('search', filters.search);
  if (filters?.status) params.set('status', filters.status);
  if (filters?.provider) params.set('provider', filters.provider);
  if (filters?.cursor) params.set('cursor', filters.cursor);
  if (filters?.limit) params.set('limit', String(filters.limit));

  const query = params.toString();
  return http.get(`/admin/subscriptions${query ? `?${query}` : ''}`);
}

/** GET /api/v1/admin/subscriptions/:id */
export async function getSubscription(id: string): Promise<{ subscription: Subscription }> {
  return http.get(`/admin/subscriptions/${id}`);
}
